import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { useParams } from 'react-router-dom';

import { useTranslation } from 'hooks/useTranslation';
import { useQueryParams } from 'hooks/useQueryParams';

import { ProfileFeedType } from 'helpers/constants';
import { LoaderColumn } from 'components';
import Icon from 'assets/icons/';

import styles from './ProfileNav.module.scss';

const getNavUsersNameQuery = gql`
  query getNavUsersName($userId: String!) {
    profileByIdentifier(identifier: $userId) {
      ... on Person {
        name
        email
      }
    }
  }
`;

export const ProfileNav = () => {
  const { t } = useTranslation();
  const { userId } = useParams();
  const query = useQueryParams();

  const { error, data } = useQuery(getNavUsersNameQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { userId },
  });

  if (data === undefined) return <LoaderColumn />;

  if (error) return <LoaderColumn />;

  const {
    profileByIdentifier: { name, email },
  } = data;

  const getFilters = (userName: string) => [
    {
      defaultActive: true,
      key: ProfileFeedType.ALL,
      label: (
        <div className={styles.navTitle}>
          <Icon.HomeFilled className={styles.icon} />
          {t('profile-screen.profile-nav.activity-feed')}
        </div>
      ),
    },
    {
      key: ProfileFeedType.OWNED,
      label: (
        <div className={styles.navTitle}>
          <Icon.DocumentFilled className={styles.icon} />
          {t('profile-screen.profile-nav.created-by')}
          {userName}
        </div>
      ),
    },
    {
      key: ProfileFeedType.SHARED,
      label: (
        <div className={styles.navTitle}>
          <Icon.ShareFilled className={styles.icon} />
          {t('profile-screen.profile-nav.shared-with')}
          {userName}
        </div>
      ),
    },
  ];

  return (
    <div className={styles.container}>
      {getFilters(name ? name : email).map((filter) => (
        <NavLink
          className={classnames(styles.navItem)}
          activeClassName={styles.active}
          // TODO Address this later
          //@ts-ignore
          isActive={(match, location) => {
            return query.get('filter') ? query.get('filter') === filter.key : filter.defaultActive;
          }}
          key={`profileFilters-${filter.key}`}
          to={`/profile/${userId}?filter=${filter.key}`}
        >
          {filter.label}
        </NavLink>
      ))}
    </div>
  );
};
